module.exports = __webpack_public_path__ + "static/media/IMG_1507.b994c6e7.jpg";